import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import routerConstant from "service/constant/routerConstant";
import type { IReviewList } from "service/interface/review";

interface Props {
  data: IReviewList[];
}

export function ReviewListTable({ data }: Props) {
  const navigate = useNavigate();

  const handleTableClick = (id: number) => {
    navigate(`${routerConstant.REVIEW.index}/${id}`);
  };

  return (
    <div className="w-ful">
      <table className="w-full divide-y divide-[#d1dff3]">
        <thead>
          <tr>
            <th
              scope="col"
              className="min-w-[55px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              ID
            </th>
            <th
              scope="col"
              className="min-w-[120px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              카테고리
            </th>
            <th
              scope="col"
              className="min-w-[498px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              제목
            </th>
            <th
              scope="col"
              className="min-w-[120px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              리뷰 작성자
            </th>
            <th
              scope="col"
              className="min-w-[120px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              별점
            </th>
            <th
              scope="col"
              className="min-w-[120px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              생성일
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {data.map((review) => (
            <tr
              key={review.id}
              className="cursor-pointer even:bg-[#fbfbfb] hover:bg-blue-2"
              onClick={() => handleTableClick(review.id)}
            >
              <td className="whitespace-nowrap px-[15px] py-[16px] text-M1 text-gray-5">
                {review.id}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                {review.category}
              </td>
              <td className="max-w-[263px] overflow-hidden text-ellipsis whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                {review.title}
              </td>
              <td className=" whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {review.writer}
              </td>
              <td className=" whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {review.score}/5
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {moment(review.createdAt).format("YYYY-MM-DD")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
